import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Promotion from '../models/Promotion';
import Urls from './../api/Urls';
import Bundle from "../models/Bundle";
import AutoFill from "../models/AutoFill";

export function getPromotions(params) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_LIST,
        params: params,
        parser: promotionsDataParser,
    }).get();
}

export function changeStatusCode(data) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_UPDATE_STATUS
    }).put({ id: data.id, note: data.note, isActive: !data.status });
}

export function getAllCampaigns() {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_CAMPAIGN_LIST_ALL
        // parser: promotionsDataParser,
    }).get();
}

export function getAllCampaignsFilter(filter) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_CAMPAIGN_LIST_ALL,
        params: filter
    }).get();
}

export function getBundlesByCampaign(campaignId) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_BUNDLE_LIST,
        params: { campaignId },
        // parser: promotionsDataParser,
    }).get();
}

export function exportExcel(params) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_EXPORT_FILE,
        isDownload: true,
        params: params,
    }).get();
}

export function checkPromotion(code) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_CHECK_CODE,
        endpointParams: { code }
    }).get();
}
                          
export function getHistoryCode(params) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_HISTORY_CODE,
        params: params,
        // parser: promotionsDataParser,
    }).get();
}

const promotionsDataParser = (data) => ({
    result: (data.result || []).map(item => new Promotion(item)),
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalCount: data.totalCount
})

// Bundles
export function getBundles(params) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_LIST,
        params: params,
        parser: bundlesDataParser,
    }).get();
}

export function getBundleDetail(id) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_DETAIL,
        endpointParams: { id },
        parser: (data) => new Bundle(data),
    }).get();
}

export function createBundleDetail(bundle) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_CREATE,
    }).post(bundle.export());
}

export function updateBundlesDetails(bundle) {
    let id = bundle.id;
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_UPDATE,
        endpointParams: { id },
    }).put(bundle.export());
}

export function updatePageDetail(bundle) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_DETAIL,
        endpointParams: { id: bundle.id },
        parser: (data) => new Bundle(data.page),
    }).put(bundle);
}

export function bundlesChangeStatus(bundle) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_CREATE,
    }).put(bundle.exportChangeStatus());
}

export function bulkUpdatePromotionStatus(data) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_ACTIVE_DEACTIVATED_CODE,
    }).post(data);
}

export function parseExcel(formData) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.BUNDLE_PARSE_EXCEL,
    }).post(formData);
}

export function fileStatusExcel(formData) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_STATUS_EXCEL,
    }).post(formData);
}

// AutoFill
export function getAutoFills(params) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AUTOFILL_LIST,
        params: params,
        parser: autoFillDataParser,
    }).get();
}

export function createAutoFill(autoFill) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AUTOFILL_CREATE,
    }).post(autoFill.export());
}

export function getAutoFillDetail(id) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AUTOFILL_DETAIL,
        endpointParams: { id },
        parser: (data) => new AutoFill(data),
    }).get();
}

export function updateAutoFill(autoFill) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AUTOFILL_UPDATE,
    }).put(autoFill.export());
}

const autoFillDataParser = (data) => ({
    result: (data.result || []).map(item => new AutoFill(item)),
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalCount: data.totalCount
})

export function updateStatusGroup(data) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_UPDATE_STATUS_GROUP,
    }).post(data);
}

export function exportSampleExcel() {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.PROMOTION_GET_FILE_SAMPLE,
        isDownload: true,
    }).get();
}
const bundlesDataParser = (data) => ({
    result: (data.result || []).map(item => new Bundle(item)),
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalCount: data.totalCount
})

